import React from 'react'
import { SelectBox as SelectBoxClass } from '../zaptic-select-box'
import { createComponent } from '@lit-labs/react'

export const SelectBox = createComponent(React, 'zaptic-select-box', SelectBoxClass, {})
